import React, { FC } from 'react'

import { Loader, ErrorHandler, InterSvgIcon } from 'components'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'

import {
  ConfirmDialogContent,
  NotificationIcon,
} from '../../styles/DisableAllNotificationsBottomsheet.styles'
import { useDisableAllNotificationsContent } from '../../hooks/useDisableAllNotificationsContent'

export interface DisableAllNotificationsBottomsheetStepTwoProps {
  onDismiss: () => void
}

export const DisableAllNotificationsBottomsheetSuccess: FC<
  DisableAllNotificationsBottomsheetStepTwoProps
> = ({ onDismiss }) => {
  const { confirmButton, details, errorOrInactive, isAppLoading, title, traceDetails, icon } =
    useDisableAllNotificationsContent({ type: 'success' })

  if (isAppLoading) return <Loader />

  if (errorOrInactive) {
    return (
      <ErrorHandler
        traceDetails={traceDetails}
        componentName={DisableAllNotificationsBottomsheetSuccess.name}
      />
    )
  }

  return (
    <ConfirmDialogContent>
      {icon && (
        <NotificationIcon>
          <InterSvgIcon iconRef={icon} width={32} height={32} color="white" />
        </NotificationIcon>
      )}
      <Text variant="headline-h3" semiBold>
        {title}
      </Text>
      <Text variant="body-3">{details}</Text>
      <Button onClick={onDismiss}>{confirmButton}</Button>
    </ConfirmDialogContent>
  )
}
